import { IEdiMessage } from 'types/graphqlTypes'
import { IEdiMessageTypesQuery } from './graphql/EdiMessageTypes'

export const getHandlerDescription = (ediMessageType: IEdiMessage): string => {
  if (ediMessageType.configurableParser) {
    return `${ediMessageType.configurableParser.name} (self-serve)`
  }

  if (ediMessageType.configurableBuilder) {
    return `${ediMessageType.configurableBuilder.name} (self-serve)`
  }

  if (ediMessageType.legacyParserClass) {
    return `${ediMessageType.legacyParserClass.replaceAll('_', '::')} (classic)`
  }

  if (ediMessageType.legacyBuilderClass) {
    return `${ediMessageType.legacyBuilderClass.replaceAll('_', '::')} (classic)`
  }

  return 'unspecified (relies on hard-coded backend routing)'
}

export const processEdiMessageTypes = (data: IEdiMessageTypesQuery | undefined) => {
  return (
    data?.ediMessageTypes.nodes
      ?.filter(item => item?.__typename === 'EdiMessage')
      .map(item => item as IEdiMessage) ?? []
  )
}
